import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import type { StyledComponentProps } from '@material-ui/core/styles';
import Spin from 'components/Spin';
import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { sendMessageChat } from 'store/Orbita/MessagingInternal/actions';
import NoDangerouslyHTML from 'v2/components/Shared/NoDangerouslyHTML';
import PermissionHide from 'v2/components/Shared/PermissionHide/index';

import styles from '../../styles/';

import type { DispatchProp } from 'react-redux';

interface IProps extends DispatchProp<any>, StyledComponentProps {
  messageSelected: number;
  loading: boolean;
  chat: any;
  updateChat: any;
  isUpdateMessages: boolean;
}

interface IStates {
  valueAnswer: string;
  sendEmail: boolean;
  loadingAnswer: boolean;
  shiftDown: boolean;
}

class MessagesChat extends Component<IProps, IStates> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      shiftDown: false,
      valueAnswer: '',
      sendEmail: false,
      loadingAnswer: false,
    };
  }

  handleChangeFieldResponse = (e: any) => {
    this.setState({ valueAnswer: e.target.value });
  };

  handleChange = (name: string) => (event: any) => {
    let newState = this.state;
    newState[name] = event.target.checked;
    this.setState(newState);
  };

  handleSendMessage = () => {
    (async () => {
      try {
        this.setState({ loadingAnswer: true });

        await this.props.dispatch(sendMessageChat(this.props.messageSelected, this.state.valueAnswer, this.state.sendEmail));
        await this.props.updateChat();

        this.setState({ valueAnswer: '', loadingAnswer: false });
        this.scrollToBottom();

        setTimeout(() => {
          this.scrollToBottom();
        }, 700);
      } catch (error) {
        this.setState({ loadingAnswer: false });
        toast.error(error);
      }
    })();
  };

  scrollToBottom = () => {
    const element = document.getElementById('chat-content');
    element.scrollTop = element.scrollHeight;
  };

  handlePressEnter = (e: any) => {
    if (e.keyCode === 16) {
      this.setState({ shiftDown: true });
    }

    if (e.key === 'Enter' && !this.state.shiftDown) {
      e.preventDefault();
      this.setState({ valueAnswer: '' });
      this.handleSendMessage();
      this.scrollToBottom();
    }
  };

  handleShiftRelease = (e: any) => {
    if (e.keyCode === 16) {
      return this.setState({ shiftDown: false });
    }
  };

  componentDidMount() {
    window['interval_chat'] = setInterval(() => {
      if (this.props.messageSelected !== 0 && localStorage.getItem('token')) {
        this.props.updateChat();
      }
    }, 12000);
  }

  componentWillUnmount() {
    window.clearInterval(window['interval_chat']);
  }

  componentDidUpdate(prevProps: IProps) {
    if (this.props.messageSelected !== prevProps.messageSelected) {
      window.clearInterval(window['interval_chat']);

      window['interval_chat'] = setInterval(() => {
        if (localStorage.getItem('token')) {
          this.props.updateChat();
        }
      }, 10000);
    }
  }

  render() {
    const { classes, messageSelected, loading, chat, isUpdateMessages } = this.props;
    const { valueAnswer, sendEmail, loadingAnswer } = this.state;

    return (
      <div className={classes.chatMessages}>
        <div className={classes.chatMessageWrapper}>
          <div className={classes.chatMessageChat} id='chat-content'>
            {!loading &&
              messageSelected !== 0 &&
              chat &&
              chat &&
              chat.length > 0 &&
              chat.map((message: any, index: any) => {
                return (
                  <div key={'chat-message-' + index} className={`${classes.chatMessageMessage} ${message.is_self ? '--producer' : ''}`}>
                    <div className={`${classes.chatMessageName}`}>
                      {message.is_self ? message.self?.name : message.outer?.name ? message.outer.name : ''}
                    </div>
                    <div className='m4'></div>

                    <NoDangerouslyHTML
                      className={`${classes.chatMessageContent} ${message.is_self ? '--producer' : ''}`}
                      html={message.content ?? 'Infelizmente não conseguimos recuperar o conteúdo desta mensagem.'}
                    />

                    <div className={`${classes.chatMessageDate}  ${message.is_self ? '--producer' : ''}`}>
                      {message.created_at && moment(message.created_at).format('DD/MM/YYYY H:mm')}
                    </div>
                  </div>
                );
              })}

            {!loading && messageSelected === 0 && <div className={classes.chatNotSelected}>Selecione uma conversa para visualizar as mensagens.</div>}

            {loading && (
              <div className={classes.chatNotSelected}>
                <Spin />
              </div>
            )}
          </div>

          {!loading && isUpdateMessages && (
            <div className={classes.updateChat}>
              <CircularProgress size={13} />
              <small>Buscando novas mensagens...</small>
            </div>
          )}
        </div>

        <div className='m16'></div>

        <div className={classes.chatAnswer}>
          <textarea
            className={classes.textarea}
            placeholder='Escreva sua mensagem'
            onChange={this.handleChangeFieldResponse}
            value={valueAnswer}
            onKeyDown={this.handlePressEnter}
            onKeyUp={this.handleShiftRelease}
            disabled={messageSelected === 0 || loading}
          ></textarea>

          <div className='m4'></div>

          <div className={classes.chatActions}>
            <div>
              <Checkbox
                checked={sendEmail}
                onChange={this.handleChange('sendEmail')}
                value='send-email'
                color='primary'
                disabled={(messageSelected === 0 && true) || loading}
                style={{ padding: 0, width: 32, height: 32 }}
              />{' '}
              Enviar cópia por e-mail
            </div>

            <div>
              <PermissionHide action={'myeduzz:meus-afiliados:editar'}>
                <Button
                  variant='contained'
                  color='secondary'
                  disabled={loadingAnswer || loading || (messageSelected === 0 && true) || !valueAnswer.length}
                  onClick={this.handleSendMessage}
                >
                  Enviar{' '}
                  {loadingAnswer && (
                    <span style={{ marginLeft: 10, position: 'relative', top: 2 }}>
                      <CircularProgress size={16} />
                    </span>
                  )}
                </Button>
              </PermissionHide>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(styles(MessagesChat));
